import { useState, useEffect, useCallback, createContext, useContext } from 'react';
import { useCouponAndModalForms } from '../../../couponAndModalFormsContext'
import { useModalForms } from '../../../../modalForms/modalFormsContext'
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'

export const TypeAndDescriptionContext = createContext();


export function TypeAndDescriptionProvider({ children }){
    const { 
        setChangeVisibleContent, 
        changeVisibleContent, 
        setFormChangeVisibleContentFromNavigatorButtons
    } = useModalForms()
  

    const {  
        couponDatasToCreateOrEdit, 
        setCouponDatasToCreateOrEdit 
    } = useCouponAndModalForms()


    const modalForms = useSelector(state => state.modalForms)

    const [couponDescription, setCouponDescription] = useState('')
    const [discountType, setDiscountType] = useState(-1)
    
    const [realCouponTypeValue, setRealCouponTypeValue] = useState(0)
    const [percentageCouponTypeValue, setPercentageCouponTypeValue] = useState(0)    
    

    const handleSetCouponInformations = useCallback(() => {
        let discountValue = discountType === 0 ?
            realCouponTypeValue : percentageCouponTypeValue

        setCouponDatasToCreateOrEdit({ 
            ...couponDatasToCreateOrEdit, 
            description: couponDescription, 
            typeDiscount: discountType, 
            discountValue:  discountValue
        })
    }, [
        couponDatasToCreateOrEdit, 
        couponDescription, 
        discountType, 
        percentageCouponTypeValue, 
        realCouponTypeValue, 
        setCouponDatasToCreateOrEdit
    ])

    

    const handleConfirmTypeAndDescription = useCallback(() => {
        if(couponDescription === '')
            toast.info('Preencha a descrição')
        else if(discountType === -1)
            toast.info('Selecione o tipo de desconto')
        else if( 
            (discountType === 0 && (realCouponTypeValue === 0 || realCouponTypeValue === '') ) 
                || 
            (discountType === 1 && (percentageCouponTypeValue === 0 || percentageCouponTypeValue === '') )
        )
            toast.info('Preencha o valor do tipo selecionado')
        else{
            handleSetCouponInformations()
            setChangeVisibleContent(1)
            setFormChangeVisibleContentFromNavigatorButtons(1)
        }

    }, [couponDescription, discountType, percentageCouponTypeValue, realCouponTypeValue, handleSetCouponInformations, setChangeVisibleContent, setFormChangeVisibleContentFromNavigatorButtons])



    useEffect(() =>{
        if(modalForms.typeModal === 0){
            setCouponDescription(couponDatasToCreateOrEdit.description)
            setDiscountType(couponDatasToCreateOrEdit.typeDiscount)
            couponDatasToCreateOrEdit.typeDiscount === 0 ?
                setRealCouponTypeValue(couponDatasToCreateOrEdit.discountValue)
                :
                setPercentageCouponTypeValue(couponDatasToCreateOrEdit.discountValue)
        }
    }, [couponDatasToCreateOrEdit, modalForms])

  

    useEffect(() => {
            if(
                couponDescription === '' 
                || discountType === -1 
                || (discountType === 0 && (realCouponTypeValue === 0 || realCouponTypeValue === '') ) 
                || (discountType === 1 && (percentageCouponTypeValue === 0 || percentageCouponTypeValue === '') ) 
            ){      
                setFormChangeVisibleContentFromNavigatorButtons(-1)
            }
    }, [
        couponDescription, 
        discountType, 
        percentageCouponTypeValue, 
        realCouponTypeValue, 
        setFormChangeVisibleContentFromNavigatorButtons,
    ])

    

    useEffect(() => {
        if(changeVisibleContent === 0){
            setFormChangeVisibleContentFromNavigatorButtons(-1)
        }
    }, [setFormChangeVisibleContentFromNavigatorButtons, changeVisibleContent])
    
    

    useEffect(() => {
        if(modalForms.isOpen === false){
            setCouponDescription('')
            setDiscountType(-1)
            setRealCouponTypeValue(0)
            setPercentageCouponTypeValue(0)
            setCouponDatasToCreateOrEdit({noEndDate: false})
        }
    }, [modalForms, setCouponDatasToCreateOrEdit])



    return(
        <TypeAndDescriptionContext.Provider 
            value={ { 
                couponDescription, setCouponDescription,
                discountType, setDiscountType,
                realCouponTypeValue, setRealCouponTypeValue,
                percentageCouponTypeValue, setPercentageCouponTypeValue,
                handleConfirmTypeAndDescription
            }}
        >
            { children }
        </TypeAndDescriptionContext.Provider>
    )
}



export function useTypeAndDescription() {
   const context = useContext(TypeAndDescriptionContext)

   if(!context) {
    throw new Error('useTypeAndDescription must be used within an Provider');
  } 

   return context
}
